import React, { useEffect } from 'react'
import Main from '../components/Home/Main'
import OurApp from '../components/Home/OurApp'
import ServicesSection from '../components/Home/ServicesSection'
import Explore from '../components/Home/Explore'
import JoinSamoolah from '../components/Home/JoinSamoolah'
import WhySamoolah from '../components/Home/WhySamoolah'
import Preview from '../components/Home/Preview'
import FAQ from '../components/Home/FAQ'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import { useTranslation } from 'react-i18next'

const Home = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;
  
  useEffect(() => {
    if (i18n.language === "ar") {
        document.body.setAttribute("dir", "rtl");
    } else {
        document.body.setAttribute("dir", "ltr");
    }
}, [i18n.language]);

  return (
    <div className=''>
      <Navbar />
      <Main />
      <OurApp />
      <ServicesSection />
      <Explore />
      <JoinSamoolah />
      <WhySamoolah />
      <Preview />
      <FAQ />
      <Footer />
    </div>
  )
}

export default Home